import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Header, Footer, LeftMenu } from '../commons/components';
import { Link } from 'react-router-dom';
import { usePageSettingHeaderStore } from '../commons/stores';
import DetailContent from './components/DetailContent';
import {getSingleTemplate} from './actions'

export default function Detail() {
  const { id } = useParams();
  const [statePageSettingHeader] = usePageSettingHeaderStore();
  const [template, setTemplate] = useState()

  const loadSingleTemplate = () => {
    getSingleTemplate(id).then(data => {
      if (data.error) {
        console.log("Error get single template")
      }
      setTemplate(data)
    })
  } 

  useEffect(() => {
    document.title = `Template Detail - Ubaform Admin`;
    loadSingleTemplate()
  }, []);


  let contentUi = <div className='loader-block' />;
 
  if (template) {
    contentUi = (
      <React.Fragment>
        <DetailContent data={template} />
      </React.Fragment>
    );
  }
  
  console.log("ini data single template", template)

  return (
    <div className='App'>
      <Header />
      {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}

      <main className='workspace'>
        <section className='breadcrumb lg:flex items-start'>
          <div>
            <h1>Template's Detail</h1>
            <ul>
              <li>
                <Link to='/template-management'>Template</Link>
              </li>
             
              <li className='divider la la-arrow-right'></li>
              <li>Template's Detail</li>
            </ul>
          </div>
          <div className='lg:flex items-center ml-auto mt-5 lg:mt-0'>
            <div className='flex mt-5 lg:mt-0'>
              <Link
                to={`/template-management/edit/${id}`}
                className='mr-3 bg-primary text-white font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Edit Template
              </Link>
              <Link
                to='/template-management'
                className='bg-transparent text-primary font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Back to list
              </Link>
            </div>
          </div>
        </section>

        {contentUi}
        <Footer />
      </main>
    </div>
  );
}
